import { styled } from '@linaria/react';

export const ProductListHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  row-gap: 3rem;

  [data-testid='heart-icon-filled'],
  [data-testid='heart-icon-outlined'] {
    scale: 1.25;
  }
`;
